/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Volume which can be connected to a workspace
 * @export
 * @interface VolumeStorage
 */
export interface VolumeStorage {
    /**
     * 
     * @type {number}
     * @memberof VolumeStorage
     */
    id?: number;
    /**
     * StorageVolume name
     * @type {string}
     * @memberof VolumeStorage
     */
    name: string;
}

export function VolumeStorageFromJSON(json: any): VolumeStorage {
    return VolumeStorageFromJSONTyped(json, false);
}

export function VolumeStorageFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeStorage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function VolumeStorageToJSON(value?: VolumeStorage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


